import React, { useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import { Menu, MenuItem } from "@mui/material";
import FilePreviewModal from "./file-preview-modal";
import { getIconBasedOnFileExt } from "../../../../../utils/fetchIconForExtension";
interface TicketAttachmentsProps {
  attachmentList: any[];
}
const TicketAttachments: React.FC<TicketAttachmentsProps> = ({
  attachmentList,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuIndex, setMenuIndex] = useState<number | null>(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [item, setItem] = useState<any>(null);

  const handleMenuOpen = (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number,
    item: any
  ) => {
    setAnchorEl(e.currentTarget);
    setMenuIndex(index);
    setItem(item);
  };
  const getFileIcon = (fileName: string) => {
    const ext = fileName?.split(".").pop()?.toLowerCase();
    return getIconBasedOnFileExt(ext || "");
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuIndex(null);
    setItem(null);
  };
  const handleViewFile = () => {
    setPreviewOpen(true);
  };
  const handleDownloadFile = () => {
    const fileUrl = item?.downloadUrl || item?.link || item?.file?.url;
    const fileName = item?.file?.original_file_name || "download";
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleMenuClose();
    } else {
      console.warn("No file URL found to download.");
    }
  };

  //to close the view preview for file
  const handleClosePreview = () => {
    setPreviewOpen(false);
    handleMenuClose();
  };

  return (
    <Box className="attachment-list-wrapper">
      {attachmentList?.map((fileItem: any, index: number) => {
        const file = fileItem;
        return (
          <div className="name-icon-wrapper" key={fileItem?.id}>
            <div className="ellipse-icon-wrapper">
              {getFileIcon(file?.originalFileName)}
              <span className="attachment-name">{file?.originalFileName}</span>
              <IconButton onClick={(e) => handleMenuOpen(e, index, fileItem)}>
                <MoreHorizIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
        );
      })}
      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            handleViewFile();
          }}
        >
          View
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleDownloadFile();
          }}
        >
          Download
        </MenuItem>
      </Menu>
      <FilePreviewModal
        open={previewOpen}
        onClose={handleClosePreview}
        fileUrl={item?.downloadUrl || item?.link || item?.file?.url || ""}
        fileName={item?.originalFileName || ""}
        id={item?.id || 0}
        previewLink={item?.previewUrl || ""}
        size={item?.file?.size || 0}
      />
    </Box>
  );
};

export default TicketAttachments;
